import {NgModule} from '@angular/core';
import {CommonModule,CurrencyPipe,TitleCasePipe} from '@angular/common';
import {MAT_DATE_FORMATS,MatRippleModule} from '@angular/material/core';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {FilterPipeModule} from 'ngx-filter-pipe';
import {TranslateModule} from '@ngx-translate/core';
import {MatLegacyAutocompleteModule as MatAutocompleteModule} from '@angular/material/legacy-autocomplete';
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import {MatLegacyMenuModule as MatMenuModule} from '@angular/material/legacy-menu';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {MatIconModule} from '@angular/material/icon';
import {MAT_LEGACY_DIALOG_DEFAULT_OPTIONS as MAT_DIALOG_DEFAULT_OPTIONS,MatLegacyDialogModule as MatDialogModule} from '@angular/material/legacy-dialog';
import {MatLegacyProgressBarModule as MatProgressBarModule} from '@angular/material/legacy-progress-bar';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatLegacyProgressSpinnerModule as MatProgressSpinnerModule} from '@angular/material/legacy-progress-spinner';
import {MatLegacyCardModule as MatCardModule} from '@angular/material/legacy-card';
import {MatLegacyChipsModule as MatChipsModule} from '@angular/material/legacy-chips';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';
import {MatLegacyTabsModule as MatTabsModule} from '@angular/material/legacy-tabs';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS,MatMomentDateModule} from '@angular/material-moment-adapter';
import {MatLegacySelectModule as MatSelectModule} from '@angular/material/legacy-select';
import {MatLegacyCheckboxModule as MatCheckboxModule} from '@angular/material/legacy-checkbox';
import {MatLegacyRadioModule as MatRadioModule} from '@angular/material/legacy-radio';
import {NgxFilesizeModule} from 'ngx-filesize';
import {MatExpansionModule} from "@angular/material/expansion";
import {DatePipeModule} from "../pipe/custom-date.module";
import {DatePipe} from "../pipe/custom-date.pipe";

@NgModule({
    imports: [CommonModule,FormsModule,ReactiveFormsModule,FilterPipeModule,RouterModule,TranslateModule,MatButtonModule,MatInputModule,MatFormFieldModule,MatAutocompleteModule,MatMenuModule,MatIconModule,MatDialogModule,MatProgressBarModule,MatProgressSpinnerModule,MatCardModule,MatChipsModule,MatTooltipModule,MatRippleModule,MatTabsModule,MatDatepickerModule,MatMomentDateModule,MatSelectModule,NgxFilesizeModule,MatCheckboxModule,MatRadioModule,MatExpansionModule,DatePipeModule],
    exports: [CommonModule,FormsModule,ReactiveFormsModule,FilterPipeModule,RouterModule,TranslateModule,MatButtonModule,MatInputModule,MatFormFieldModule,MatAutocompleteModule,MatMenuModule,MatIconModule,MatDialogModule,MatProgressBarModule,MatProgressSpinnerModule,MatCardModule,MatChipsModule,MatTooltipModule,MatRippleModule,MatTabsModule,MatDatepickerModule,MatMomentDateModule,MatSelectModule,NgxFilesizeModule,MatCheckboxModule,MatRadioModule,MatExpansionModule,DatePipeModule],
    providers: [{
        provide: MAT_DIALOG_DEFAULT_OPTIONS,
        useValue: {
            autoFocus: false,
            minWidth: 800,
            hasBackdrop: true,
            disableClose: true
        }
    },{
        provide: MAT_DATE_FORMATS,
        useValue: {
            display: {
                dateInput: 'L',
                monthYearLabel: 'MMM YYYY',
                dateA11yLabel: 'LL',
                monthYearA11yLabel: 'MMMM YYYY'
            },
            parse: {
                dateInput: ['L','DD/MM/YYYY','DDMMYYYY','DD/MM/YY','DDMMYY','DD/MM','DDMM']
            }
        }
    },{
        provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
        useValue: {
            useUtc: false,
            strict: true
        }
    },CurrencyPipe,DatePipe,TitleCasePipe]
})
export class CoreComponentsModule {
}
